import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid2,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import XCloseIco from "../../../../assets/icons/XCloseIco";
import GreenTick from "../../../../assets/images/green-tick.png";
import CommonButton from "../../../../component/Button";
import { StyledFlexColumnView } from "../../../common-components/StyledComponents";

function SubmitBidPopup({ activateDialogOpen, handleActivateDialogClose }) {
  const navigate = useNavigate();

  return (
    <Dialog
      fullWidth
      maxWidth={"xs"}
      open={activateDialogOpen}
      sx={{
        "& .MuiDialog-paper": {
          width: "400px",
          maxWidth: "none",
          borderRadius: "12px",
          background: "#FFF",
          boxShadow:
            "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
        },
      }}
    >
      <img
        src={GreenTick}
        style={{
          position: "absolute",
          width: "max-content",
          opacity: "0.9",
          marginTop: "20px",
          marginLeft: "20px",
        }}
      />
      <DialogActions>
        <Button onClick={handleActivateDialogClose} sx={{ marginTop: "10px" }}>
          <XCloseIco />
        </Button>
      </DialogActions>

      <DialogContent>
        <Grid2 spacing={2} container>
          <Grid2 size={12}>
            <Typography
              color="#344054"
              fontSize={18}
              fontFamily={"Inter"}
              fontWeight={500}
              sx={{
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
            >
              {"Submission Successful !"}
            </Typography>
          </Grid2>

          <Grid2 size={12}>
            <Typography
              color="#667085"
              fontSize={14}
              fontFamily={"Inter"}
              fontWeight={500}
              sx={
                {
                  // whiteSpace: "nowrap",
                  // textOverflow: "ellipsis",
                  // overflow: "hidden",
                }
              }
            >
              {
                "The Project Atlantis proposal has been successfully submitted to Charles McKensie."
              }
            </Typography>
          </Grid2>

          <Grid2 size={12}>
            <StyledFlexColumnView style={{ gap: "18px" }}>
              <CommonButton
                variant="contained"
                color="white"
                background="#7F56D9"
                fontWeight="600"
                value="View Proposal"
                padding="8px 15px"
                onClick={handleActivateDialogClose}
              />
              <CommonButton
                variant="outlined"
                color="#344054"
                border="#D0D5DD"
                fontWeight="700"
                value="Back to Sow Invites"
                padding="8px 15px"
                boxShadow={"0px 1px 2px 0px rgba(16, 24, 40, 0.05)"}
                onClick={() => navigate(`/bidding-engine`)}
              />
            </StyledFlexColumnView>
          </Grid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
}

export default SubmitBidPopup;
